import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=52f22c43&scoped=true&"
import script from "./ContentTitle.vue?vue&type=script&lang=js&"
export * from "./ContentTitle.vue?vue&type=script&lang=js&"
import style0 from "./ContentTitle.vue?vue&type=style&index=0&id=52f22c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f22c43",
  null
  
)

export default component.exports